import { FC } from 'react';
import style from './executive-summary.module.scss';

interface ExecutiveSummaryCardProps {
  label: string;
  value: string;
}

const ExecutiveSummaryCard: FC<ExecutiveSummaryCardProps> = ({
  label,
  value,
}) => (
  <div className={style.card}>
    <div className={style.cardValue}>{value}</div>
    <div className={style.cardLabel}>{label}</div>
  </div>
);

export { ExecutiveSummaryCard };
